import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styles from './psq.module.scss'
import InputWTN from 'components/generic/InputWTN'
import { FieldValidator } from 'formik'

interface Props {
  inputProps: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
  heading: string
  introText?: string
  answerId: string
  validator?: FieldValidator
}

const PsqInputAnswer = ({ heading, introText, inputProps, answerId, validator }: Props) => {
  const { t } = useTranslation('strPsq')
  return (
    <div className={styles.questionWrapper}>
      <div id={answerId}>
        <h2 className={styles.formHeading}>
          <strong>{heading}</strong>
        </h2>
      </div>
      {introText} <InputWTN {...inputProps} name={answerId} validate={validator} />
    </div>
  )
}

export default PsqInputAnswer
